export const userAccountValidate = (formValue, userProfileValue) => {

    const errors = {}

    if (!formValue.firstName.trim()) {
        errors.firstName = "لطفا نام را وارد کنید"
    } else {
        delete errors.firstName
    }

    if (!formValue.lastName.trim()) {
        errors.lastName = "لطفا نام خانوادگی را وارد کنید"
    } else {
        delete errors.lastName
    }

    // if (formValue.cardId === "") {
    //     errors.cardId = "لطفا شماره شناسنامه را وارد کنید"
    // } else {
    //     delete errors.cardId
    // }

    if (!formValue.phone.trim()) {
        errors.phone = "لطفا شماره موبایل را وارد کنید"
    } else {
        delete errors.phone
    }

    if (!formValue.email.trim()) {
        errors.email = "لطفا ایمیل را وارد کنید"
    } else if (!/\S+@\S+\.\S+/.test(formValue.email)) {
        errors.email = "Email address is invalid"
    } else {
        delete errors.email
    }

    // if (formValue.birthDate == "") {
    //     errors.birthDate = "لطفا تاریخ تولد خود را وارد کنید"
    // } else {
    //     delete errors.birthDate
    // }

    if (userProfileValue === "") {
        errors.images = "لطفا عکس را انتخاب نمایید"
    } else {
        delete errors.images
    }

    return errors;

}